var render = function render(){var _vm=this,_c=_vm._self._c;return _c('navbar',{attrs:{"navbar-menu-classes":"navbar-right"}},[_c('template',{slot:"navbar-menu"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }